import React from 'react'
import { NavLink, useSearchParams } from 'react-router-dom'
import { equalString } from '@/util/strings.ts'

export interface INavItem {
    id: string
    label: string
    href: string
    tab?: string
}

export interface IProps extends INavItem {
    className?: string
}

const NotificationNavItem: React.FC<IProps> = ({ className, label, href, tab = '' }) => {
    const [searchParams] = useSearchParams()

    const isActive = equalString(tab, searchParams?.get('tab') || '')

    return (
        <div className={`${className}`}>
            <NavLink
                to={href}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all
                    ${isActive ? 'bg-black text-white' : 'bg-gray-300 text-gray-500'}
                `}
            >
                {label}
            </NavLink>
        </div>
    )
}

export default NotificationNavItem
